// components/TrackingHeader.jsx - Improved focused version
import React from 'react';
import { Link } from 'react-router-dom';

const TrackingHeader = () => {
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm backdrop-blur-sm bg-white/95">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-6">
          {/* Logo Section - Left */}
            <div className="flex items-center gap-3">
              <img 
                src="/logo.png" 
                alt="Wayuvega Logo" 
                className="h-12 w-auto object-contain transition-transform duration-200 hover:scale-105"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <div className="flex flex-col">
                <span className="text-2xl font-bold text-blue-600 leading-tight">
                  Wayuvega
                </span>
                <span className="text-sm text-gray-600 font-medium tracking-wide">
                  Shipments Tracking
                </span>
              </div>
            </div>

          {/* Merchant Signup Link - Right */}
          <Link
            to="/merchant-signup"
            className="hidden sm:flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200 transform hover:scale-105"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
            <span>Become a Merchant</span>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default TrackingHeader;